export class Gallery {

	constructor(){

		this.slider = $('.c-gallery');
		this.init();

	}


	init(){

		this.slider.slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 1000,
			fade: true,
			autoplay: true,
			autoplaySpeed: 2000,
			cssEase: 'linear'
		});

	}

}


// WEBPACK FOOTER //
// ./src/js/modules/gallery.js